export default "__VITE_ASSET__DIbLelDp__"